













import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import { ModelShowModel } from '../../../model/model/ModelShowModel';

import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';
import { ModelApi } from '@/context/model/api/ModelApi';

@Component({
  components: { ProgressSpinnerWrapper, DetailRow }
})
export default class ModelShowContainer extends mixins(ShowContainer) {
  model!: ModelShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await ModelApi.instance().show(id);
    this.model = response?.data?.view;
  }
}
